import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import "./utils.css" ; 
import SideBar from './SideBar';
import { Outlet } from 'react-router-dom';
import HeaderComponent from './HeaderComponent';
import { useSelector } from 'react-redux';
import { getLanguage } from '../../RTK/Slice/UserSlice';

const SharedComponent = () => {

      // For Control Show Sidebar
      const [showSide , setShowSide] = useState(true) ; 
  
      const handleShowSide = ()=>{
          setShowSide(!showSide)
      }

    const {t , i18n}  = useTranslation() ; 

    const lng = useSelector(getLanguage); 


    // For Change Language To Arabic
    const handleArabic  = ()=>{
      localStorage.setItem("i18nextLng" , "ar") ;
      i18n.changeLanguage("ar")

    }

    // For Change Language To English 
    const handleEnglish  = ()=>{
      localStorage.setItem("i18nextLng" , "en") ;
      i18n.changeLanguage("en")

    }


  return (
    <main className='main-section my-font'>
      <SideBar showSide={showSide} handleShowSide={handleShowSide}  />
      <section className='sub-main' style={{ width : "100%" , maxWidth : "100%" , marginLeft : "25px" , marginRight : "25px"}}>
        <HeaderComponent handleShowSide={handleShowSide}  handleArabic={handleArabic} handleEnglish={handleEnglish} />

        <Outlet />
      </section>
      
    </main>
  )
}

export default SharedComponent
